/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavParsePreviewLoiter
 */
export interface OutputUavParsePreviewLoiter {
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreviewLoiter
     */
    headingDeg?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreviewLoiter
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreviewLoiter
     */
    lng?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavParsePreviewLoiter
     */
    radiusM?: number;
}

/**
 * Check if a given object implements the OutputUavParsePreviewLoiter interface.
 */
export function instanceOfOutputUavParsePreviewLoiter(value: object): boolean {
    return true;
}

export function OutputUavParsePreviewLoiterFromJSON(json: any): OutputUavParsePreviewLoiter {
    return OutputUavParsePreviewLoiterFromJSONTyped(json, false);
}

export function OutputUavParsePreviewLoiterFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavParsePreviewLoiter {
    if (json == null) {
        return json;
    }
    return {
        
        'headingDeg': json['headingDeg'] == null ? undefined : json['headingDeg'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'radiusM': json['radiusM'] == null ? undefined : json['radiusM'],
    };
}

export function OutputUavParsePreviewLoiterToJSON(value?: OutputUavParsePreviewLoiter | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'headingDeg': value['headingDeg'],
        'lat': value['lat'],
        'lng': value['lng'],
        'radiusM': value['radiusM'],
    };
}

